/* eslint-disable */
(($) => {
  Drupal.behaviors.globalNav = {
    attach(context) {
      var globalDTW      = '.site--wayne-county-airport-authority';
      var globalWR       = '.site--willow-run-airport';
      var globalBusiness = '.page--business' + globalDTW;
      var tabDTW         = '.tabs--item--detroit-metro';
      var tabWR          = '.tabs--item--willow-run';
      var tabBusiness    = '.tabs--item--business';
      var active         = 'section-active';

      // Detroit Metro
      $(globalDTW).find(tabDTW).addClass(active);
      $(globalDTW).find(tabBusiness).removeClass(active);

      // Willow Run
      $(globalWR).find(tabWR).addClass(active);

      // Detroit Metro - Business
      $(globalBusiness).find(tabBusiness).addClass(active);
      $(globalBusiness).find(tabDTW).removeClass(active);
    },
  };
})(jQuery);